import { Component, OnInit } from '@angular/core';
import { Ng2DeviceService } from 'ng2-device-detector';

import { RestaurantEvent } from './restaurant-event';

import { RestaurantService } from './restaurant.service';
import { NavigationComponent }  from './navigation.component';
import { TopDetailsComponent }  from './top-details.component';

import 'rxjs/add/operator/switchMap';

@Component({
	selector: 'event-book',
	templateUrl: './event-book.component.html',
	styleUrls: ['./event-book.component.css'] 

})

export class EventBookComponent implements OnInit {
    deviceInfo = null;
        device = "unknown";
	constructor(
 
		private m_restaurant_service: RestaurantService,
                  private deviceService: Ng2DeviceService,
            
  	) {}

	m_events: RestaurantEvent[];

	ngOnInit(): void {
		this.getRestaurantEvents();
	}

	getRestaurantEvents(): void {
		console.log("EventsComponent getRestaurantEvents")
		this.m_restaurant_service.getRestaurantEvents(this.m_restaurant_service.name).then(
			restaurantEvents => {
				console.log("EventsComponent callback")
				console.log("EventsComponent callback restaurantEvents: " + restaurantEvents)
				this.m_events = restaurantEvents;
                                this.deviceInfo = this.deviceService.getDeviceInfo();
                                this.device = this.deviceInfo.device;
                      
                                
			}
		);
	}
}


// WEBPACK FOOTER //
// /Users/kala/Sites/weeloy_website_engine/website-new-template-fun/src/app/event-book.component.ts